import type {Collection} from 'api/types';
import type {Schemas} from 'api/dto.generated';
import {mapGetCollectionDto} from 'api/mappers/mapCollectionDto';
import {ebsApi} from 'store/ebsApi';

const seriesApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getSeries: build.query<
      Collection,
      Pick<Collection, 'id'>,
      Schemas.SeriesWithRelationsDto
    >({
      keepUnusedDataFor: 60,
      query: ({id}) => ({
        url: `series/${id}`,
      }),
      transformResponse: mapGetCollectionDto,
      providesTags: (_, __, {id}) => [{type: 'Series', id}],
    }),
  }),
});

export const {useGetSeriesQuery} = seriesApi;
